var map = {
	"./cie/logo-dark.svg": 994,
	"./cie/logo-white.svg": 995,
	"./cie/logo.svg": 996,
	"./ciss-icons/amh/amhSanta.svg": 997,
	"./ciss-icons/amh/solid.svg": 998,
	"./ciss-icons/amh/text-landscape.svg": 999,
	"./ciss-icons/amh/text-large.svg": 1000,
	"./ciss-icons/amh/transparent.svg": 1001,
	"./ciss-icons/amh/white.svg": 1002,
	"./ciss-icons/diary/solid.svg": 1003,
	"./ciss-icons/diary/transparent.svg": 1004,
	"./ciss-icons/diary/white.svg": 1005,
	"./ciss-icons/directory/solid.svg": 1006,
	"./ciss-icons/directory/transparent.svg": 1007,
	"./ciss-icons/directory/white.svg": 1008,
	"./ciss-icons/vaks/solid.svg": 1009,
	"./ciss-icons/vaks/transparent.svg": 1010,
	"./ciss-icons/vaks/white.svg": 1011,
	"./flags/aboriginal.svg": 1012,
	"./flags/lgbt.svg": 1013,
	"./flags/torres-strait.svg": 1014,
	"./healthengine/logo-white.svg": 1015,
	"./healthengine/logo.svg": 1016,
	"./markers-svg/diary.svg": 1017,
	"./markers-svg/directory.svg": 1018,
	"./markers/diary.png": 1019,
	"./markers/directory.png": 1020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 993;